import { useMutation } from '@tanstack/react-query'
import { adminApi } from '~/api'
import { AWS_REGIONS } from '~/utils/constants'
import { showErrors } from '~/utils/helpers'
import { type ApiMutationResult } from '~/utils/types'

export const useCreateServerMutation = (): ApiMutationResult => {
  return useMutation(async (values) => {
    const region = AWS_REGIONS.find((i) => i.code === values.region_code)
    return await adminApi.createServer({
      ...values,
      region: region?.name
    })
  }, {
    onError: showErrors
  })
}

export const useUpdateServerMutation = (id): ApiMutationResult =>
  useMutation(async (values) => {
    const region = AWS_REGIONS.find((i) => i.code === values.region_code)
    return await adminApi.updateServer(id, {
      ...values,
      region: region?.name
    })
  }, {
    onError: showErrors
  })

export const useDeleteServerMutation = (): ApiMutationResult =>
  useMutation(async (serverId: number) => await adminApi.removeServer(serverId))

export const useCreateAppstreamMutation = (): ApiMutationResult =>
  useMutation(async (values: any) => {
    return await adminApi.createAppstream({ ...values })
  })

export const useUpdateAppstreamMutation = (id: number): ApiMutationResult =>
  useMutation(async (values: any) => {
    return await adminApi.updateAppstream(id, values)
  })

export const useDeleteAppstreamMutation = (): ApiMutationResult =>
  useMutation(async (id) => {
    return await adminApi.deleteAppstream(id)
  }, {
    onError: showErrors
  })

export const useSyncServersMutation = (courseId: number): ApiMutationResult =>
  useMutation(async () => {
    return await adminApi.syncServers(courseId)
  })

export const useSyncSingleServerMutation = (): ApiMutationResult =>
  useMutation(async (serverId) => {
    return await adminApi.syncServer(serverId)
  })
